import { render, staticRenderFns } from "./LeftSideMainMenu.vue?vue&type=template&id=3941ac84&"
import script from "./LeftSideMainMenu.vue?vue&type=script&lang=js&"
export * from "./LeftSideMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideMainMenu.vue?vue&type=style&index=0&id=3941ac84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports